import withEditarUsuarioSesion from "../../hoc/withTrabajadores/withEditarUsuarioSesion";
import EditarNombreUsuario from "../../view/components/RegistroUsuarios/DatosSesion/EditarDatosSesion/EditarNombreUsuario";

export default withEditarUsuarioSesion(EditarNombreUsuario);